<template>
  <div class="BoardView">
    <Wrap :class="wrap">
      <div v-if="title" class="BoardView-title">
        <Row>
          <Column :sm="hasButton ? 8 : 12" :xs="hasButton ? 6 : 12">
            <h2>
              {{ title }}
            </h2>
            <div>
              {{ sub }}
            </div>
          </Column>
          <Column v-if="hasButton" :sm="4" :xs="6">
            <slot name="button" />
          </Column>
        </Row>
        <TableSearch
          v-if="table"
          :table="table"
          @update:search="setSearch"
          @update:sortIndex="setSort" />
      </div>
      <div class="BoardView-inner">
        <slot v-if="isLoaded" />
        <Empty v-else>
          <Loader class="lg info" />
          {{ $t('loading') }}
        </Empty>
      </div>
      <TableNav
        v-if="table"
        :table="table"
        :total="total"
        @change="setPage" />
    </Wrap>
  </div>
</template>

<script>
import { actions, getters } from '../../utils'
import Pagination from 'mixins/Pagination'

export default {
  mixins: [Pagination],
  props: {
    table: Object,
    title: String,
    sub: String,
    total: Number,
    wrap: {
      default: 'na',
      type: String,
    },
  },
  computed: {
    hasButton() {
      return this.$slots.button
    },
    ...getters(),
  },
  methods: {
    setSort(sortIndex) {
      this.PATCH_TABLE({
        table: this.table,
        sortIndex,
        page: 0,
      })
    },
    setSearch(search) {
      this.PATCH_TABLE({
        table: this.table,
        page: 0,
        search,
      })
    },
    setPage(page) {
      this.PATCH_TABLE({
        table: this.table,
        page,
      })
    },
    ...actions(
      'PATCH_TABLE',
    ),
  },
}
</script>

<style lang="scss">
.BoardView {
  .BoardView-title {
    border-bottom: 1px solid $border-color;
    margin-bottom: 1rem;
    padding: 2rem 0;
    @include md {
      .Btn span.add {
        display: inline-block;
      }
    }

    h2 {
      @include ellipsis;
      line-height: 3rem;
      margin: 0;
      text-transform: none;
    }

    .Btn span.add {
      display: none;
    }
  }

  > .FormSect {
    box-shadow: $shadow-md;
    padding: 0.5rem 0;
  }

  h3, h4 {
    color: $text-color-mid;
  }

  > .list, .TableSearch {
    border-top: 1px solid $border-color;
    margin-top: 1rem;
    padding-top: 1rem;
    @include md {
      padding-top: 1.5rem;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "loading": "Loading"
  }
}
</i18n>
